
import TableList from "@components/templates/tablelist";
import { HttpBillTypeList } from "@/service/newbigaccount";
import { mapGetters } from "vuex";
import comIndex from './update';
import mixin from '../mixin';
export default {
    mixins: [TableList,mixin],
    components: {
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_status:0,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpBillTypeList,
        interceptRequest(params) {
            params.billingChannel = 'PAYABLE'
            return params
        },
        handleOperates(params = "", type, batch) {

            switch (type) {

                case "edit":
                    var url=this.$router.resolve({
                        name: "payPricemaintainDetail",
                        params: { type: "edit" },
                        query: { code: params.expenseCategoryCustomizeCode, orgid:params.organizationId,billtype:params.billtype },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "query":
                    this.operate = {
                        title:'查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "payPricemaintainDetail",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/billing/billDelivery/export', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'post',
                    })
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id } = row
            return [{
                label:'查看',
                show:true,
                params:{expenseCategoryCustomizeCode:row.code,organizationId:row.hostOrganizationId,billtype:row.expenseCategoryType},
                operate:'query'
            },{
                label:'编辑',
                show:true,
                params:{expenseCategoryCustomizeCode:row.code,organizationId:row.hostOrganizationId,billtype:row.expenseCategoryType},
                operate:'edit'
            },]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getCusBillTypeList']),
        SearchsData() {
            return [
                {
                    label: '费用类型',
                    tag: 'vSelect',
                    key: 'EQ_expenseCategoryType',
                    options: this.getCusBillTypeList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: '费用类型代码',
                    tag: 'vInput',
                    key: 'CN_code',
                    show: true,
                },
                {
                    label: '订单类型',
                    tag: 'vSelect',
                    key: 'CN_orderType',
                    options:this.getOrderList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: '创建日期',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                },

            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    width: 120,
                    render:this.getOperateNodes,
                },
                {
                    title: '费用类型',
                    key: 'expenseCategoryType',
                    render: (h, { row }) => this.findRenderLabel(this.getCusBillTypeList, row.expenseCategoryType),
                },
                {
                    title: '订单类型',
                    key: 'orderType',
                    render: (h, { row }) => {
                        if (!row.orderType || row.orderType == 0) return <div>--</div>
                        let textArr = row.orderType.split(',').map(value => {
                            return this.getOrderList.filter(item => {
                                return item.value == value
                            })[0].label;
                        });
                        return textArr.join(',');
                    }
                },
                {
                    title: '费用类型代码',
                    key: 'code',
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                },
            ];
        },

    },

};
